module.exports = __webpack_public_path__ + "img/table_gray.7944c34a.svg";